import ProductCategoryCreate from './ProductCategoryCreate'
export {ProductCategoryCreate}
export default ProductCategoryCreate
